// // import React from 'react';
// // import { createRoot } from 'react-dom/client';
// // import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
// // import Login from './views/Login';
// // import Dashboard from './views/Dashboard';
// // import Tables from './views/Tables';
// // import Menu from './views/Menu';
// // import Orders from './views/Orders';
// // import TableView from './views/TableView';
// // import Inventory from './views/Inventory';
// // import Waiter from './views/Waiter';
// // import Backup from './views/Backup';
// // import Nav from './components/Nav';
// // import OrderFromCustomer from "./views/OrderFromCustomer";
// // import Analytics from './views/Analytics';
// // import './styles.css';

// // function App() {
// //   const [user, setUser] = React.useState(() => {
// //     try {
// //       return JSON.parse(localStorage.getItem('user'));
// //     } catch (e) {
// //       return null;
// //     }
// //   });

// //   return (
// //     <HashRouter>
// //       {/* Sidebar Navigation */}
// //       <Nav user={user} setUser={setUser} />

// //       {/* Main Content Area */}
// //       <div className="min-h-screen p-6 transition-all duration-300 md:ml-64 bg-gray-50">
// //         <Routes>
// //           <Route path="/login" element={<Login setUser={setUser} />} />
// //           <Route path="/" element={user ? <Dashboard user={user} /> : <Navigate to="/login" />} />
// //           <Route path="/tables" element={user ? <Tables user={user} /> : <Navigate to="/login" />} />
// //           <Route path="/orders" element={user ? <Orders user={user} /> : <Navigate to="/login" />} />
// //           <Route path="/tables/:id" element={user ? <TableView user={user} /> : <Navigate to="/login" />} />
// //           <Route path="/menu" element={user ? <Menu user={user} /> : <Navigate to="/login" />} />
// //           <Route path="/inventory" element={user ? <Inventory user={user} /> : <Navigate to="/login" />} />
// //           <Route path="/waiter" element={<Waiter />} />
// //           <Route path="/waiter/table/:id" element={<TableView />} />
// //           <Route path="/order/:tableId" element={<OrderFromCustomer />} />
// //           <Route path="/backup" element={<Backup />} />
// //           <Route path="/analytics" element={user ? <Analytics /> : <Navigate to="/login" />} />
// //         </Routes>
// //       </div>
// //     </HashRouter>
// //   );
// // }

// // // Force reload only once per network change to switch server mode
// // if (!window._networkHandlerAdded) {
// //   window._networkHandlerAdded = true;
// //   let hasReloaded = false;

// //   const reloadApp = () => {
// //     if (!hasReloaded) {
// //       hasReloaded = true;
// //       console.log("🔄 Switching environment... reloading app");
// //       setTimeout(() => window.location.reload(), 400); 
// //     }
// //   };

// //   window.addEventListener("online", () => {
// //     console.log("✅ Internet connected — switching to ONLINE mode");
// //     reloadApp();
// //   });

// //   window.addEventListener("offline", () => {
// //     console.log("⚠️ Offline — switching to LOCAL server mode");
// //     reloadApp();
// //   });
// // }


// // createRoot(document.getElementById('root')).render(<App />);


// import React from 'react';
// import { createRoot } from 'react-dom/client';
// import { HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import Login from './views/Login';
// import Dashboard from './views/Dashboard';
// import Tables from './views/Tables';
// import Menu from './views/Menu';
// import Orders from './views/Orders';
// import TableView from './views/TableView';
// import Inventory from './views/Inventory';
// import Waiter from './views/Waiter';
// import Backup from './views/Backup';
// import Nav from './components/Nav';
// import OrderFromCustomer from "./views/OrderFromCustomer";
// import Analytics from './views/Analytics';
// import './styles.css';

// function AppContent() {
//   const [user, setUser] = React.useState(() => {
//     try {
//       return JSON.parse(localStorage.getItem('user'));
//     } catch (e) {
//       return null;
//     }
//   });

//   const location = useLocation();

//   // Check if URL has ?waiter=true
//   const searchParams = new URLSearchParams(location.search);
//   const isWaiterMode = searchParams.get('waiter') === 'true';

//   return (
//     <>
//       {/* Show Nav only if NOT waiter mode */}
//       {!isWaiterMode && <Nav user={user} setUser={setUser} />}

//       <div className={`min-h-screen p-6 transition-all duration-300 ${isWaiterMode ? "" : "md:ml-64"} bg-gray-50`}>
//         <Routes>
//           <Route path="/login" element={<Login setUser={setUser} />} />
//           <Route path="/" element={user ? <Dashboard user={user} /> : <Navigate to="/login" />} />
//           <Route path="/tables" element={user ? <Tables user={user} /> : <Navigate to="/login" />} />
//           <Route path="/orders" element={user ? <Orders user={user} /> : <Navigate to="/login" />} />
//           <Route path="/tables/:id" element={user ? <TableView user={user} /> : <Navigate to="/login" />} />
//           <Route path="/menu" element={user ? <Menu user={user} /> : <Navigate to="/login" />} />
//           <Route path="/inventory" element={user ? <Inventory user={user} /> : <Navigate to="/login" />} />
//           <Route path="/waiter" element={<Waiter />} />
//           <Route path="/waiter/table/:id" element={<TableView />} />
//           <Route path="/order/:tableId" element={<OrderFromCustomer />} />
//           <Route path="/backup" element={<Backup />} />
//           <Route path="/analytics" element={user ? <Analytics /> : <Navigate to="/login" />} />
//         </Routes>
//       </div>
//     </>
//   );
// }

// function App() {
//   return (
//     <HashRouter>
//       <AppContent />
//     </HashRouter>
//   );
// }

// // Force reload logic (unchanged)
// if (!window._networkHandlerAdded) {
//   window._networkHandlerAdded = true;
//   let hasReloaded = false;

//   const reloadApp = () => {
//     if (!hasReloaded) {
//       hasReloaded = true;
//       console.log("🔄 Switching environment... reloading app");
//       setTimeout(() => window.location.reload(), 400); 
//     }
//   };

//   window.addEventListener("online", () => {
//     console.log("✅ Internet connected — switching to ONLINE mode");
//     reloadApp();
//   });

//   window.addEventListener("offline", () => {
//     console.log("⚠️ Offline — switching to LOCAL server mode");
//     reloadApp();
//   });
// }

// createRoot(document.getElementById('root')).render(<App />);


import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './views/Login';
import Dashboard from './views/Dashboard';
import Tables from './views/Tables';
import Menu from './views/Menu';
import Orders from './views/Orders';
import TableView from './views/TableView';           // Normal table view
import WaiterTableView from './views/WaiterTableView'; // Waiter mode table view
import Inventory from './views/Inventory';
import Waiter from './views/Waiter';
import Backup from './views/Backup';
import Nav from './components/Nav';
import OrderFromCustomer from "./views/OrderFromCustomer";
import Analytics from './views/Analytics';
import './styles.css';

function AppContent() {
  const [user, setUser] = React.useState(() => {
    try {
      return JSON.parse(localStorage.getItem('user'));
    } catch (e) {
      return null;
    }
  });

  const location = useLocation();

// Check if URL is waiter mode
const searchParams = new URLSearchParams(location.search);
const isQueryWaiter = searchParams.get('waiter') === 'true';

// OR path starts with /waiter
const isPathWaiter = location.pathname.startsWith("/waiter");

const isWaiterMode = isQueryWaiter || isPathWaiter;


  return (
    <>
      {/* Show Nav only if NOT waiter mode */}
      {!isWaiterMode && <Nav user={user} setUser={setUser} />}

      <div className={`min-h-screen p-6 transition-all duration-300 ${isWaiterMode ? "" : "md:ml-64"} bg-gray-50`}>
        <Routes>
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="/" element={user ? <Dashboard user={user} /> : <Navigate to="/login" />} />
          <Route path="/tables" element={user ? <Tables user={user} /> : <Navigate to="/login" />} />
          <Route path="/orders" element={user ? <Orders user={user} /> : <Navigate to="/login" />} />
          <Route path="/tables/:id" element={user ? <TableView user={user} /> : <Navigate to="/login" />} />
          <Route path="/menu" element={user ? <Menu user={user} /> : <Navigate to="/login" />} />
          <Route path="/inventory" element={user ? <Inventory user={user} /> : <Navigate to="/login" />} />
          <Route path="/waiter" element={<Waiter />} />
          <Route path="/waiter/table/:id" element={<WaiterTableView />} />
          <Route path="/order/:tableId" element={<OrderFromCustomer />} />
          <Route path="/backup" element={<Backup />} />
          <Route path="/analytics" element={user ? <Analytics /> : <Navigate to="/login" />} />
        </Routes>
      </div>
    </>
  );
}

function App() {
  return (
    <HashRouter>
      <AppContent />
    </HashRouter>
  );
}

// Force reload logic (unchanged)
if (!window._networkHandlerAdded) {
  window._networkHandlerAdded = true;
  let hasReloaded = false;

  const reloadApp = () => {
    if (!hasReloaded) {
      hasReloaded = true;
      console.log("🔄 Switching environment... reloading app");
      setTimeout(() => window.location.reload(), 400); 
    }
  };

  window.addEventListener("online", () => {
    console.log("✅ Internet connected — switching to ONLINE mode");
    reloadApp();
  });

  window.addEventListener("offline", () => {
    console.log("⚠️ Offline — switching to LOCAL server mode");
    reloadApp();
  });
}

createRoot(document.getElementById('root')).render(<App />);